<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>마이페이지</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">마이페이지</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">회원정보</p>
          <ul class="depth">
            <li><router-link to="/mypagemain" title="회원정보">회원정보</router-link></li>
            <li><router-link to="/mypageprepayment" title="서비스 이용내역">서비스 이용내역</router-link></li>
            <li><router-link to="/mypagediscountpayment" title="웹 선불권 이용내역">웹 선불권 이용내역</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">비밀번호 입력</h3>
        <article class="mypageForm">
          <div class="authentication mypage">
            <p class="subTile">회원정보 확인을 위해 비밀번호를 입력 해 주세요.</p>
            <input
              type="password"
              title="비밀번호 입력"
              placeholder="비밀번호 입력"
              v-model="password"
              @keydown.enter="passwordCheck"
            />
            <div class="btnArea">
              <button type="button" class="btn gray" @click="$router.push('/Main')">취소</button>
              <button type="button" class="btn blue" @click="passwordCheck">확인</button>
            </div>
          </div>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import { required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      empNo: this.$store.state.empNo,
      password: '',
    };
  },

  validations: {
    password: {
      required,
    },
  },

  methods: {
    validationCheck() {
      if (!this.$v.password.required) {
        alert('비밀번호를 입력하여주십시오.');
        return false;
      }
      return true;
    },

    async passwordCheck() {
      if (!this.validationCheck()) return;

      const res = await axios('post', '/api/member/pw-check', null, {
        params: {
          empNo: this.empNo,
          password: this.password,
        },
      });
      const data = res.data;
      if (!data.result) {
        alert('일치하지 않는 비밀번호입니다.');
        this.password = '';
        return;
      }
      this.$router.push({
        path: 'mypageupdate',
        query: { check: this.empNo },
      });
    },
  },
};
</script>
